import React, { useState } from "react";
import { Modal, Form, Input, Rate } from "antd";
import { Close, FeedbackOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

function Feedback({ variant = "sidebar", collapsed = false, companyContext }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setModalOpen(false);
    form.resetFields();
  };

  const submitFeedback = (values) => {
    setLoading(true);
    const payload = {
      rating: values.rating,
      review: values.review ?? "-",
      company_name: companyContext?.company_name ?? null,
      user_input: companyContext?.user_input ?? null,
    };
    const { http } = global.services;
    http
      .post("buyers-feedback", payload)
      .then(() => {
        closeModal();
        toast.success("Feedback submitted successfully");
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      })
      .finally(() => setLoading(false));
  };

  const triggerButton =
    variant === "sidebar" ? (
      <div className={`sidebar-feedback-wrap ${collapsed ? "collapsed" : ""}`}>
        <button
          type="button"
          className="sidebar-feedback-btn"
          onClick={openModal}
          title="Share feedback"
        >
          <FeedbackOutlined className="sidebar-feedback-icon" />
          {!collapsed && <span className="sidebar-feedback-label">Share feedback</span>}
        </button>
      </div>
    ) : null;

  return (
    <>
      {triggerButton}
      <Modal
        visible={modalOpen}
        onCancel={closeModal}
        footer={null}
        width={560}
        closable={false}
        className="feedback-modal feedback-modal-improved"
      >
        <button type="button" className="close-btn" onClick={closeModal}>
          <Close />
        </button>
        <div className="feedback-modal-header">
          <span className="feedback-modal-badge">We're listening</span>
          <h2 className="feedback-modal-title">Help us improve</h2>
          <p className="feedback-modal-description">
            Your feedback shapes what we build next. Rate your experience and tell us what
            you'd like to see—we read every response.
          </p>
        </div>
        <Form form={form} onFinish={submitFeedback}>
          <Form.Item
            name="rating"
            label="Rating"
            rules={[{ required: true, message: "Rating is required" }]}
            getValueFromEvent={(value) => value}
          >
            <Rate style={{ color: "#fadb14" }} />
          </Form.Item>
          <Form.Item
            name="review"
            label="Review"
            rules={[
              { max: 500, message: "Review should not exceed 500 characters" },
              { whitespace: true, message: "Review should not be empty" },
            ]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>
          <div className="action-box">
            <button type="button" onClick={closeModal}>
              Cancel
            </button>
            <button type="submit" className="submit" disabled={loading}>
              {loading ? <BeatLoader size={8} color="#000" /> : "Submit"}
            </button>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default Feedback;
